var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-card',{class:[
      { 'on-hover': hover || _vm.isActiveOption },
      ("" + (_vm.$vuetify.breakpoint.smAndDown ? 'py-5' : 'py-10')),
      'pointer',
      'px-6',
      'd-flex align-center flex-column justify-center' ],style:(("boxShadow: 0px " + (_vm.isActiveOption || hover
      ? '6px 35px rgba(0, 0, 0, 0.2)'
      : '6px 30px rgba(0, 0, 0, 0.08)') + " !important; border-radius: 7px")),attrs:{"max-width":_vm.$vuetify.breakpoint.smAndDown ? 200 : 344,"min-width":_vm.$vuetify.breakpoint.smAndDown ? 200 : 344,"to":_vm.option.to,"color":_vm.isActiveOption ? 'primary' : ''},on:{"click":function($event){$event.stopPropagation();return _vm.openApplicationList(false)}}},[_c('div',{staticClass:"justify-center align-center d-flex flex-wrap"},[_c('v-icon',{attrs:{"size":_vm.$vuetify.breakpoint.smAndDown ? 100 : 150,"color":_vm.isActiveOption ? 'white' : 'primary'}},[_vm._v(" "+_vm._s(_vm.option.icon)+" ")])],1),_c('v-card-title',{class:[
        ("" + (_vm.$vuetify.breakpoint.smAndDown ? 'body-2' : '')),
        'font-weight-bold',
        ("" + (_vm.isActiveOption ? 'white--text' : 'primary--text')),
        'd-flex',
        'justify-center',
        'text-center',
        'word-break',
        'font-weight-bold',
        'pb-1'
      ]},[_vm._v(" "+_vm._s(_vm.titleUpperCase)+" ")]),_c('v-card-text',{class:[
        ("" + (_vm.$vuetify.breakpoint.smAndDown ? 'caption' : '')),
        ("" + (_vm.isActiveOption ? 'white--text' : 'black--text')),
        'text-center',
        'd-none',
        'd-sm-block',
        'font-weight-light' ]},[_vm._v(" "+_vm._s(_vm.option.description)+" ")])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }